import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { persistStore } from "redux-persist"
import { Reducers } from "./reducers"
import logger from "redux-logger"
import { setData } from "./app/Actions";

let store
let persist
export const getStore = () => store
export const getPersist = () => persist
export default function configureStore() {
  const enhancer = compose(applyMiddleware(thunk, logger))
  store = createStore(Reducers, enhancer)

  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept("./reducers", () => {
        store.replaceReducer(Reducers)
      })
    }
  }

  persist = persistStore(store, {}, () => {
    store.dispatch(setData({rehydrated: true}))
  })
  return store
}
